import AxiosAPI from './AxiosAPI';
import utility from '../shared/utility';

class Subscription extends AxiosAPI {
  createSubscription(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/subscribe/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  switchSubscription(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/web/switch-plan', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  fetchSubscriptionPlans(currencyCode) {
    const annualPlanEnabled = utility.annualPlanFlag();
    const reqUrl = annualPlanEnabled ? 'v2/zuora/products' : 'v1/zuora/products';
    return new Promise((resolve, reject) => {
      super.getList(reqUrl, { product_type: 'WebStore', currency: currencyCode }).then((resp) => {
        let plan = null;
        if (resp && resp.success && resp.products.length) {
          const product = resp.products[0];
          [plan] = product.productRatePlans;
        }
        // using new pricing vuex store post annual plan changes
        if (resp && resp.success && resp.products.length && annualPlanEnabled) {
          window.$store.dispatch('setPricingPlans', { response: resp, currencyCode });
        }
        // FIXME TEMPORARY HARD-CODED RESPONSE DATA --START
        if (process.env.NODE_ENV === 'development' && !resp.holiday_promo) {
          plan.holiday_promo = {
            id: '2c92c0f96e63a4df016e6424a24d320a',
            upToPeriods: '12',
            endDateCondition: 'Fixed_Period',
            upToPeriodsType: 'Months',
            pricing: [
              {
                currency: 'USD',
                discountAmount: '4',
              },
              {
                currency: 'GBP',
                discountAmount: '4',
              },
              {
                currency: 'CAD',
                discountAmount: '4',
              },
              {
                currency: 'EUR',
                discountAmount: '4',
              },
              {
                currency: 'NZD',
                discountAmount: '4',
              },
              {
                currency: 'ZAR',
                discountAmount: '4',
              },
              {
                currency: 'AUD',
                discountAmount: '4',
              },
            ],
          };
        }
        if (resp && resp.success && resp.holiday_promo) {
          plan.holiday_promo = resp.holiday_promo;
        }
        // FIXME TEMPORARY HARD-CODED RESPONSE DATA --END
        resolve({ plan, originalResponse: resp });
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  getSubscription() {
    return new Promise((resolve, reject) => {
      super.getList('v1/zuora/subscription', {}).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  cancelSubscription() {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/unsubscribe').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  updatePaymentInfo(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/payment/credit-card', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  fetchTransactionHistory(params) {
    return new Promise((resolve, reject) => {
      super.getList('v1/user/transactions', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  validateAndStorePromoCode(promoCode, currency) {
    return new Promise((resolve, reject) => {
      const { activePlan } = window.$store.getters;
      super.get(`v1/zuora/promo/${promoCode}/validate`, { productRatePlans: activePlan && activePlan.id ? activePlan.id : '', currency }).then((resp) => {
        resolve(resp);
        if (resp && resp.valid) {
          localStorage.setItem('promo_code', promoCode);
          if (resp.promoData && resp.promoData.ratePlan) {
            const plan = resp.promoData.ratePlan[0];
            if (plan && plan.id) {
              const currentDate = new Date();
              currentDate.setMonth(currentDate.getMonth() + parseInt(plan.upToPeriods, 10));
              localStorage.setItem('promo_trial_end_date', currentDate);
              localStorage.setItem('promo_trial_period', parseInt(plan.upToPeriods, 10));
              const { promoData } = window.$store.getters;
              promoData.promoCode = promoCode;
              promoData.trialPeriod = parseInt(plan.upToPeriods, 10);
              promoData.trialEndDate = currentDate;
              window.$store.dispatch('setPromoData', promoData);
            }
          }
        }
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getTransactionDetails(transactionId) {
    return new Promise((resolve, reject) => {
      super.get(`v1/user/transactions-details/${transactionId}`).then((resp) => {
        if (resp) {
          resolve(resp);
        }
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  subscriptionWithOldCard(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/resubscribe/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }
}

export default Subscription;
